<ng-container *ngIf="mainForm !== undefined && control">
  <div [formGroup]="mainForm" class="inputField {{layoutModifier}}">
    <button type="button" (click)="togglePasswordVisibility()" class="pwToggle">
      <i svgIcon [icon]="(type !== 'password') ? 'eye_open' : 'eye_closed'"></i>
    </button>

    <input [attr.type]="type" [formControlName]="controlName" [placeholder]="placeholder">
  </div>

  <app-form-password-errors [control]="control" [showCondition]="showCondition"></app-form-password-errors>

</ng-container>
